(ns dre.modals.modal-window
  (:require
   [dre.i18n.views :refer [tr]]
   [dre.components.loading-spinner :refer [full-size-loading-spinner-overlay]]
   [dre.modals.events :as-alias modals]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(defn modal-window
  [{:keys [title sub-title content loading?
           delete? delete-text on-delete delete-disabled?
           submit? submit-text on-submit submit-disabled?
           on-close-fx]}]
  (let [component-name :modal-window]
    [:div
     {:class [component-name]}
     (when loading?
       [full-size-loading-spinner-overlay])
     [:div
      {:class (bem/be component-name :header)}
      [:div
       {:class (bem/be component-name :header-title)}
       [:h3 (if (string? title)
              [tr title]
              title)]
       (when sub-title
         [:h5 (if (string? sub-title)
                [tr sub-title]
                sub-title)])]]
     [:div
      {:class (bem/be component-name :content)}
      [content]]
     [:div
      {:class (bem/be component-name :footer)}
      [:button.button
       {:on-click #(do 
                     (when on-close-fx
                       (rf/dispatch [on-close-fx]))
                     (rf/dispatch [::modals/clear]))}
       [tr "Cancel"]]
      (when submit?
        [:button.button.button--brand
         {:on-click (or on-submit (constantly nil))
          :class (when (or loading?
                           submit-disabled?) "button--disabled")}
         (or submit-text [tr "Submit"])])
      (when delete?
        [:button.button.button--danger
         {:on-click (or on-delete (constantly nil))
          :class (when (or loading?
                           delete-disabled?) "button--disabled")}
         (or delete-text [tr "Delete"])])]]))
